import React, { FC } from 'react'
import copy from 'copy-to-clipboard'

import { CardDropdown, Dropdown } from '@sketch/components'
import { useToast } from '@sketch/toasts'
import { useFlag } from '@sketch/modules-common'

export interface PrototypeCardDropdownProps {
  pathname: string
  prototypeId: string
}

const PrototypeCardDropdown: FC<PrototypeCardDropdownProps> = ({
  pathname,
  prototypeId,
}) => {
  const { showToast } = useToast()
  const isBetterPrototypeNavBarOn = useFlag('better-prototype-nav-bar')
  const isWebGLPrototypePlayerOn = useFlag('webgl-prototype-player')
  const shouldAttachPrototypeIdToUrl =
    !isWebGLPrototypePlayerOn && isBetterPrototypeNavBarOn

  const copyLink = (
    withHotspots: boolean,
    event: React.SyntheticEvent<Element, Event>
  ) => {
    event.preventDefault()

    const queryString = getQueryString(
      prototypeId,
      withHotspots,
      shouldAttachPrototypeIdToUrl
    )

    const link = `${window.location.origin}${pathname}${queryString}`
    copy(link)
    showToast('Link to Prototype copied', 'positive')
  }

  return (
    <CardDropdown placement="bottom-start" usePortal>
      <Dropdown.Item onClick={event => copyLink(true, event)}>
        Copy link to Prototype with Hotspots
      </Dropdown.Item>
      <Dropdown.Item onClick={event => copyLink(false, event)}>
        Copy link to Prototype with Hotspots disabled
      </Dropdown.Item>
    </CardDropdown>
  )
}

function getQueryString(
  prototypeId: string,
  withHotspots: boolean,
  shouldAttachPrototypeIdToUrl: boolean
) {
  const params = []
  if (shouldAttachPrototypeIdToUrl) {
    params.push(`prototype=${prototypeId}`)
  }

  if (!withHotspots) {
    params.push('hotspots=false')
  }

  return params.length ? `?${params.join('&')}` : ''
}

export default PrototypeCardDropdown
